import { useState } from 'react';

import { Icon, Spinner } from '@iwoca/orion';
import { useLingui } from '@lingui/react/macro';
import clsx from 'clsx';

import styles from './SaveProgressButton.module.css';
import { useLocale } from '../../hooks/useLocale';
import { Button } from '../Button/Button';

const SaveProgressButton = () => {
  const [saveStatus, setSaveStatus] = useState<'idle' | 'loading' | 'success'>(
    'idle',
  );

  const { isDE } = useLocale();
  const { t } = useLingui();

  const buttonMessage =
    saveStatus === 'loading'
      ? t`Saving progress`
      : saveStatus === 'success'
        ? t`Progress saved`
        : t`Save progress`;

  const isDisabled = saveStatus === 'loading' || saveStatus === 'success';

  const fakeSaveApplication = () => {
    setSaveStatus('loading');
    setTimeout(() => {
      setSaveStatus('success');
      setTimeout(() => setSaveStatus('idle'), 3000);
    }, 700);
  };

  return (
    <Button
      className={clsx(styles.container, isDE && styles.containerDE)}
      onClick={fakeSaveApplication}
      disabled={isDisabled}
      variant="secondary"
    >
      <span>{buttonMessage}</span>
      {saveStatus === 'loading' ? (
        <Spinner size="small" dataTestId="loading-spinner" />
      ) : saveStatus === 'success' ? (
        <Icon icon="checkCircleOutline" data-testid="save-success-icon" />
      ) : (
        <Icon icon="save" data-testid="save-icon" />
      )}
    </Button>
  );
};

export default SaveProgressButton;
